/**
 * @file offline/offlineDb.js
 * @description Dexie (IndexedDB) database setup for offline-first inspection storage.
 * All inspection data is stored locally first, then synced to the server.
 * Tables mirror the server schema with sync metadata fields.
 */
import Dexie from "dexie";

const db = new Dexie("InspectionButlerOffline");

// Schema version 1 — initial offline tables
db.version(1).stores({
  // Inspections — local cache of all inspections
  inspections: "id, _serverId, _syncStatus, _lastModified, status, companyId, inspectorId, templateId",

  // Inspection responses — individual item answers
  responses: "id, _serverId, _syncStatus, _lastModified, inspectionId, templateItemId",

  // Photos — stored as blobs in IndexedDB
  photos: "id, _serverId, _syncStatus, _lastModified, inspectionId, responseId",

  // Templates — cached for offline new-inspection creation
  templates: "id, _lastModified, companyId, isSystem, isPublic",

  // Template sections
  templateSections: "id, templateId, sortOrder",

  // Template items
  templateItems: "id, sectionId, sortOrder",

  // Sync queue — ordered list of operations to sync
  syncQueue: "++id, table, recordId, operation, createdAt, status",

  // Conflict log — records that had sync conflicts
  conflictLog: "++id, table, recordId, createdAt",

  // Cached dashboard data
  dashboardCache: "key, _lastModified"
});

// Schema version 2 — Customer Butler (CRM) offline tables.
// Additive: existing v1 tables are preserved; these mirror the server CRM
// schema with the same sync metadata (_serverId, _syncStatus, _lastModified)
// so the existing syncQueue + syncEngine handle them with no special casing.
db.version(2).stores({
  customers: "id, _serverId, _syncStatus, _lastModified, companyId, status, displayName",
  properties: "id, _serverId, _syncStatus, _lastModified, companyId, customerId",
  contacts: "id, _serverId, _syncStatus, _lastModified, companyId, customerId",
  agents: "id, _serverId, _syncStatus, _lastModified, companyId",
  tasks: "id, _serverId, _syncStatus, _lastModified, companyId, status, customerId, dueAt"
});

export default db;
